var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{staticClass:"app-background"},[_c('notifications',{attrs:{"group":"main","data-cy":"toast"}}),_c('v-main',{staticClass:"safe-area-bottom main-content"},[_c('transition',{attrs:{"name":"page-transition","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }